var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H7C4.75439 3 3 4.75439 3 7V9H21V7C21 4.75439 19.2456 3 17 3ZM5 9H19V17C19 18.2632 18.2632 19 17 19H7C5.73684 19 5 18.2632 5 17V9ZM3 7V17C3 19.2456 4.75439 21 7 21H17C19.2456 21 21 19.2456 21 17V7H3ZM6 2V4C6 4.54386 6.45614 5 7 5C7.54386 5 8 4.54386 8 4V2C8 1.45614 7.54386 1 7 1C6.45614 1 6 1.45614 6 2ZM18 4V2C18 1.45614 17.5439 1 17 1C16.4561 1 16 1.45614 16 2V4C16 4.54386 16.4561 5 17 5C17.5439 5 18 4.54386 18 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.cd6abe77.svg";
export { ForwardRef as ReactComponent };